import { Link } from "react-router-dom";
import { categories } from "@/mocks/animeData";

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/70 mt-16 md:mt-24">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-9 h-9 rounded-md bg-primary-600 text-foreground-950 font-heading text-lg flex items-center justify-center">
              色
            </span>
            <span className="font-heading text-xl text-foreground-950">色情动漫</span>
            <span className="inline-flex items-center h-5 px-1.5 rounded border border-accent-600/60 text-[10px] font-label tracking-widest text-accent-400">
              18+
            </span>
          </div>
          <p className="text-sm text-foreground-500 leading-relaxed max-w-md">
            成人向动画作品的资料聚合与介绍站点。我们整理作品信息、分类标签与更新动态，帮助成年观众更快找到想看的内容。
          </p>
          <p className="mt-4 text-xs text-foreground-400 leading-relaxed max-w-md">
            本站不提供任何影片播放、下载或付费服务，所有作品信息仅作介绍与索引用途。请勿向未成年人传播本站内容。
          </p>
        </div>

        <div>
          <h4 className="text-sm text-foreground-900 mb-4 tracking-wide">
            <Link to="/category" className="hover:text-accent-400 transition-colors">
              浏览分类
            </Link>
          </h4>
          <ul className="flex flex-col gap-2.5">
            {categories.slice(0, 5).map((item) => (
              <li key={item.slug}>
                <Link
                  to={`/category?category=${encodeURIComponent(item.slug)}`}
                  className="text-sm text-foreground-500 hover:text-accent-400 transition-colors"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm text-foreground-900 mb-4 tracking-wide">
            <Link to="/about" className="hover:text-accent-400 transition-colors">
              关于本站
            </Link>
          </h4>
          <ul className="flex flex-col gap-2.5">
            <li>
              <Link to="/latest" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors">最新更新</Link>
            </li>
            <li>
              <Link to="/popular" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors">热门推荐</Link>
            </li>
            <li>
              <Link to="/search" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors">全站搜索</Link>
            </li>
            <li>
              <a href="mailto:contact@sese-anime.example" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors">
                联系编辑部
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 lg:px-12 py-5 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-foreground-400">© 2026 色情动漫 · 内容仅面向 18 岁以上用户</p>
        <p className="text-xs text-foreground-400">本站为内容介绍演示站 · 无播放与下载功能</p>
      </div>
    </footer>
  );
}